// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function GridPinnedRows(_) {
  return null;
}